import ColumnLayout from '../../../../main/components/column-layout';
import { JigyoList } from './jigyoList.presenter';
import { useJigyoListContainer } from './jigyoList.container.hooks';
import { IContentsContentElem } from 'app-template-lib/utils';
import { TContentsContentParams } from '@/shared/t-contents-params';
import { useQuery } from '@apollo/client';
import { FETCH_M_LG_CONFIG } from '@/main/queries/setting_m_lg_config.queries.type';
import setting_m_lg_configQueries from '@/main/queries/setting_m_lg_config.queries';

/**
 * 事業一覧ページ
 * @returns
 */
export function JigyoListPage({ formID, params }: IContentsContentElem<TContentsContentParams>) {
    // 事業一覧ページのContainerカスタムフック
    const { data, onNavigate, lgConfigData, urlParams } = useJigyoListContainer();
    const { lgcode, jigyoYear } = urlParams;

    return (
        <ColumnLayout>
            <JigyoList
                {...{
                    formID,
                    params,
                    lgcode,
                    onNavigate,
                    data,
                    jigyoYear,
                    lgConfigData,
                }}
            />
        </ColumnLayout>
    );
}
